import React, { useState, useMemo, useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import { useCart } from '../context/CartContext';
import MiniCart from '../components/MiniCart';

const allChipsData = [
  // Chips 100g
  { name: 'Chipsuri „Crab"', weight: 100, price: 6.90, image: require('../assets/Crab 100 g.png'), category: '100g' },
  { name: 'Chipsuri „Bacon"', weight: 100, price: 6.90, image: require('../assets/Bacon 100 g.png'), category: '100g' },
  { name: 'Chipsuri „Cașcaval"', weight: 100, price: 6.90, image: require('../assets/Cheese 100 g.png'), category: '100g' },
  { name: 'Chipsuri „Costițe"', weight: 100, price: 6.90, image: require('../assets/Ribs 100 g.png'), category: '100g' },
  { name: 'Chipsuri „Legume la Grătar"', weight: 100, price: 6.90, image: require('../assets/Fried Vegetables 100 g.png'), category: '100g' },
  { name: 'Chipsuri „Chilli & Lime"', weight: 100, price: 6.90, image: require('../assets/LEODOR_CHIPS_CHILI_100G.png'), category: '100g' },
  { name: 'Chipsuri „Smântână și Ceapă"', weight: 100, price: 6.90, image: require('../assets/ceapa.png'), category: '100g' },
  { name: 'Chipsuri „Tomate și ardei iute"', weight: 100, price: 6.90, image: require('../assets/Tomato 100 g.png'), category: '100g' },

  // Chips 150g
  // { name: 'Chipsuri cu Crab', weight: 150, price: 8.50, image: require('../assets/Crab 150 g new.png'), category: '150g' },
  // { name: 'Chipsuri cu Costiță', weight: 150, price: 8.50, image: require('../assets/Ribs 150 g new.png'), category: '150g' },
  // { name: 'Chipsuri cu Pizza', weight: 150, price: 8.50, image: require('../assets/Pizza 150 g new.png'), category: '150g' },
  // { name: 'Chipsuri cu Bacon', weight: 150, price: 8.50, image: require('../assets/Bacon 150 g new.png'), category: '150g' },

  // Chips 60g
  { name: 'Chipsuri „Cașcaval"', weight: 60, price: 3.89, image: require('../assets/Cheese 60 g.png'), category: '60g' },
  { name: 'Chipsuri „Chilli & Lime"', weight: 60, price: 3.89, image: require('../assets/LEODOR_CHIPS_CHILI_60G.png'), category: '60g' },
  { name: 'Chipsuri „Costițe"', weight: 60, price: 3.89, image: require('../assets/Ribs 60 g.png'), category: '60g' },
  { name: 'Chipsuri „Sare"', weight: 60, price: 3.89, image: require('../assets/Sare 60 g.png'), category: '60g' },
  { name: 'Chipsuri „Smântână și Ceapă"', weight: 60, price: 3.89, image: require('../assets/ceapa.png'), category: '60g' },

  // Sticks 70g
  { name: 'Sticks „Bacon"', weight: 70, price: 3.89, image: require("../assets/Sticks Leod'or gust de bacon 70gr.png"), category: '70g' },
  { name: 'Sticks „Cașcaval"', weight: 70, price: 3.89, image: require("../assets/Sticks Leod'or gust de cascaval 70gr.png"), category: '70g' },
  { name: 'Sticks „Smântână & verdeață"', weight: 70, price: 3.89, image: require("../assets/Sticks Leod'or gust de smantana cu verdeata 70gr.png"), category: '70g' },
];

const yellow = '#f3e81c'; // Added this line

const ShopPage = styled.div`
  background: ${yellow}; // Changed from #f9f9f9
  min-height: 100vh;
  font-family: 'Inter', Arial, sans-serif;
  margin: 0;
  padding: 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 6rem auto 0; /* Changed */
  padding: 2rem;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    margin: 85px auto 0;
    padding: 1.5rem;
  }
  
  @media (max-width: 768px) {
    margin: 70px auto 0;
    padding: 1rem;
  }
  
  @media (max-width: 600px) {
    margin: 60px auto 0;
    padding: 1rem;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 2rem;
  text-align: center;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 2.2rem;
    margin-bottom: 1.8rem;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
`;

const Filters = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    gap: 0.8rem;
    margin-bottom: 1.8rem;
  }
  
  @media (max-width: 700px) {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }
`;

const FilterButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  @media (max-width: 700px) {
    gap: 0.5rem;
  }
`;

const FilterButton = styled.button`
  background: ${({ active }) => 
    active 
      ? 'linear-gradient(135deg, #FF6B00 0%, #FF8533 100%)' 
      : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
  };
  color: ${({ active }) => (active ? 'white' : '#2d3748')};
  border: 1px solid ${({ active }) => (active ? '#FF6B00' : '#e2e8f0')};
  padding: 0.7rem 1.2rem;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  box-shadow: ${({ active }) => 
    active 
      ? '0 6px 20px rgba(255, 107, 0, 0.3), 0 2px 8px rgba(255, 107, 0, 0.2)' 
      : '0 4px 12px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)'
  };
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ active }) => 
      active 
        ? '0 8px 25px rgba(255, 107, 0, 0.4), 0 4px 12px rgba(255, 107, 0, 0.3)' 
        : '0 6px 20px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)'
    };
    background: ${({ active }) => 
      active 
        ? 'linear-gradient(135deg, #e05a00 0%, #ff7420 100%)' 
        : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)'
    };
  }

  &:active {
    transform: translateY(-1px);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 0.3s ease;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const ChipsDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const ChipsButton = styled.button`
  background: ${({ active }) => 
    active 
      ? 'linear-gradient(135deg, #FF6B00 0%, #FF8533 100%)' 
      : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
  };
  color: ${({ active }) => (active ? 'white' : '#2d3748')};
  border: 1px solid ${({ active }) => (active ? '#FF6B00' : '#e2e8f0')};
  padding: 0.7rem 1.2rem;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  box-shadow: ${({ active }) => 
    active 
      ? '0 6px 20px rgba(255, 107, 0, 0.3), 0 2px 8px rgba(255, 107, 0, 0.2)' 
      : '0 4px 12px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)'
  };
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
    gap: 0.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
    gap: 0.4rem;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ active }) => 
      active 
        ? '0 8px 25px rgba(255, 107, 0, 0.4), 0 4px 12px rgba(255, 107, 0, 0.3)' 
        : '0 6px 20px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)'
    };
    background: ${({ active }) => 
      active 
        ? 'linear-gradient(135deg, #e05a00 0%, #ff7420 100%)' 
        : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)'
    };
  }

  &:active {
    transform: translateY(-1px);
  }

  &::after {
    content: '▼';
    font-size: 0.7rem;
    margin-left: 0.3rem;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(0deg)')};
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 0.3s ease;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const ChipsDropdown = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e0e6ed;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  min-width: 140px;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: row;
  margin-left: 0.5rem;
  overflow: hidden;
  animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    margin-left: 0.3rem;
    min-width: 120px;
  }
  
  @media (max-width: 480px) {
    margin-left: 0.2rem;
    min-width: 100px;
  }
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(-12px) scale(0.9);
    }
    to {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
  }
`;

const SticksDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const SticksButton = styled.button`
  background: ${({ active }) => 
    active 
      ? 'linear-gradient(135deg, #FF6B00 0%, #FF8533 100%)' 
      : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
  };
  color: ${({ active }) => (active ? 'white' : '#2d3748')};
  border: 1px solid ${({ active }) => (active ? '#FF6B00' : '#e2e8f0')};
  padding: 0.7rem 1.2rem;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  box-shadow: ${({ active }) => 
    active 
      ? '0 6px 20px rgba(255, 107, 0, 0.3), 0 2px 8px rgba(255, 107, 0, 0.2)' 
      : '0 4px 12px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)'
  };
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
    gap: 0.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
    gap: 0.4rem;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ active }) => 
      active 
        ? '0 8px 25px rgba(255, 107, 0, 0.4), 0 4px 12px rgba(255, 107, 0, 0.3)' 
        : '0 6px 20px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)'
    };
    background: ${({ active }) => 
      active 
        ? 'linear-gradient(135deg, #e05a00 0%, #FF6B00 100%)' 
        : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)'
    };
  }

  &:active {
    transform: translateY(-1px);
  }

  &::after {
    content: '▼';
    font-size: 0.7rem;
    margin-left: 0.3rem;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(0deg)')};
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const SticksDropdown = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e0e6ed;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  min-width: 120px;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  margin-left: 0.5rem;
  overflow: hidden;
  animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    margin-left: -2.5rem;
    min-width: 100px;
  }
  
  @media (max-width: 480px) {
    margin-left: -2.7rem;
    min-width: 80px;
  }
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(-12px) scale(0.9);
    }
    to {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
  }
`;

const ChipsDropdownItem = styled.button`
  flex: 1;
  padding: 0.7rem 1rem;
  border: none;
  background: ${({ active }) => 
    active 
      ? 'linear-gradient(135deg, #FF6B00 0%, #FF8533 100%)' 
      : 'transparent'
  };
  color: ${({ active }) => (active ? 'white' : '#2d3748')};
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: ${({ active }) => (active ? '700' : '600')};
  font-size: 0.9rem;
  position: relative;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    padding: 0.5rem 0.7rem;
    font-size: 0.8rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
  }
  
  &:hover {
    background: ${({ active }) => 
      active 
        ? 'linear-gradient(135deg, #e05a00 0%, #ff7420 100%)' 
        : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)'
    };
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:first-child {
    border-radius: 16px 0 0 16px;
    border-right: 1px solid #e2e8f0;
  }
  &:last-child {
    border-radius: 0 16px 16px 0;
  }
  &:only-child {
    border-radius: 16px;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 0.3s ease;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const SticksDropdownItem = styled.button`
  width: 100%;
  padding: 0.7rem 1rem;
  border: none;
  background: ${({ active }) => 
    active 
      ? 'linear-gradient(135deg, #FF6B00 0%, #FF8533 100%)' 
      : 'transparent'
  };
  color: ${({ active }) => (active ? 'white' : '#2d3748')};
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: ${({ active }) => (active ? '700' : '600')};
  font-size: 0.9rem;
  position: relative;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    padding: 0.5rem 0.7rem;
    font-size: 0.8rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
  }
  
  &:hover {
    background: ${({ active }) => 
      active 
        ? 'linear-gradient(135deg, #e05a00 0%, #ff7420 100%)' 
        : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)'
    };
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:first-child {
    border-radius: 16px 16px 0 0;
  }
  &:last-child {
    border-radius: 0 0 16px 16px;
  }
  &:only-child {
    border-radius: 16px;
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid #e2e8f0;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 0.3s ease;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const SortDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const SortButton = styled.button`
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  color: #2d3748;
  border: 1px solid #e2e8f0;
  padding: 0.7rem 1.2rem;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08);
    background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  }

  &:active {
    transform: translateY(-1px);
  }

  &::after {
    content: '▼';
    font-size: 0.7rem;
    margin-left: 0.3rem;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${({ open }) => (open ? 'rotate(-90deg)' : 'rotate(0deg)')};
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const SortDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e0e6ed;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  min-width: 180px;
  display: ${({ open }) => (open ? 'block' : 'none')};
  margin-top: 0.5rem;
  overflow: hidden;
  animation: ${({ open }) => (open ? 'slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none')};
  backdrop-filter: blur(10px);
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-12px) scale(0.9);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

const SortDropdownItem = styled.button`
  width: 100%;
  padding: 0.7rem 1rem;
  border: none;
  background: ${({ active }) => 
    active 
      ? 'linear-gradient(135deg, #FF6B00 0%, #FF8533 100%)' 
      : 'transparent'
  };
  color: ${({ active }) => (active ? 'white' : '#2d3748')};
  text-align: left;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: ${({ active }) => (active ? '700' : '600')};
  font-size: 0.9rem;
  position: relative;
  letter-spacing: 0.5px;
  
  &:hover {
    background: ${({ active }) => 
      active 
        ? 'linear-gradient(135deg, #e05a00 0%, #ff7420 100%)' 
        : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)'
    };
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:first-child {
    border-radius: 16px 16px 0 0;
  }
  &:last-child {
    border-radius: 0 0 16px 16px;
  }
  &:only-child {
    border-radius: 16px;
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid #e2e8f0;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 0.3s ease;
    border-radius: inherit;
    pointer-events: none;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 1.8rem;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.5rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const ProductCard = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0,0,0,0.1);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: contain;
  padding: 1rem;
`;

const LargerProductImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: contain;
  padding: 0 1rem 0.5rem 1rem;
  margin-top: 0rem;
`;

const ChiliProductImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: contain;
  padding: 0 1rem 0.5rem 1rem;
  margin-top: -0.5rem;
`;

const ProductInfo = styled.div`
  padding: 1rem;
  text-align: center;
  border-top: 1px solid #f0f0f0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ChiliProductInfo = styled.div`
  padding: 1rem;
  text-align: center;
  border-top: 1px solid #f0f0f0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: -0.8rem;
`;

const SareProductInfo = styled.div`
  padding: 1rem;
  text-align: center;
  border-top: 1px solid #f0f0f0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: -1.2rem;
`;

const ProductName = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  line-height: 1.3;
  min-height: 2.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChiliProductName = styled.h3`
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 0.1rem;
  margin-top: 1.8rem;
  line-height: 1.2;
  min-height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const ProductPrice = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  color: #FF6B00;
  margin-bottom: 1rem;
`;

const ChiliProductPrice = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  color: #FF6B00;
  margin-bottom: 1rem;
  margin-top: 1.9rem;
`;

const SareProductName = styled.h3`
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 0.1rem;
  margin-top: 1.2rem;
  line-height: 1.2;
  min-height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const SareProductPrice = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  color: #FF6B00;
  margin-bottom: 1rem;
  margin-top: 2.4rem;
`;

const AddToCartButton = styled.button`
  background: linear-gradient(135deg, #FF6B00 0%, #FF8533 100%);
  color: white;
  border: none;
  padding: 0.7rem 1.5rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(255, 107, 0, 0.3);
  position: relative;
  overflow: hidden;
  
  &:hover {
    background: linear-gradient(135deg, #e05a00 0%, #FF6B00 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 107, 0, 0.4);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(255, 107, 0, 0.3);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.5s;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  @media (max-width: 700px) {
    font-size: 1.1rem;
    padding: 0.9rem 1.2rem;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
    align-items: flex-start;
    padding-top: 2rem;
  }
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 18px;
  padding: 2rem;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    padding: 1.5rem;
    max-height: 85vh;
    width: 100%;
    max-width: none;
    margin: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
`;

const ModalTitle = styled.h2`
  color: #222;
  margin: 0;
  font-size: 1.5rem;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0.5rem;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  &:hover {
    background: #f0f0f0;
  }
`;

const ModalText = styled.div`
  color: #444;
  font-size: 1rem;
  line-height: 1.6;
  white-space: pre-line;
  
  h3 {
    color: #FF6B00;
    margin: 1.5rem 0 1rem 0;
    font-size: 1.2rem;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0;
  }
  
  th, td {
    padding: 0.5rem;
    text-align: left;
    border-bottom: 1px solid #eee;
  }
  
  th {
    background: #f8f9fa;
    font-weight: 600;
    color: #2d3748;
  }
`;

const Shop = () => {
  const [filter, setFilter] = useState('all');
  const [sort, setSort] = useState('price-asc');
  const [chipsDropdownOpen, setChipsDropdownOpen] = useState(false);
  const [sticksDropdownOpen, setSticksDropdownOpen] = useState(false);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);

  const filteredAndSortedChips = useMemo(() => {
    let items = [...allChipsData];

    if (filter !== 'all') {
      items = items.filter(chip => chip.category === filter);
    }

    items.sort((a, b) => {
      if (sort === 'price-asc') {
        return a.price - b.price;
      } else {
        return b.price - a.price;
      }
    });

    return items;
  }, [filter, sort]);

  const { addToCart, cart } = useCart();
  const [miniCartOpen, setMiniCartOpen] = useState(false);
  const [selectedChip, setSelectedChip] = useState(null);

  // Данные о составе чипсов
  const chipsInfo = {
    'Chipsuri „Crab"': {
      ingredients: 'cartofi (61 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (32 %), zer dulce praf (din lapte), zahăr, sare alimentară, dextroză, praf de ardei roșu, proteine din lapte, lactoză, aromă (conține produse lactate), extract de drojdie, potențiatori de aromă (monoglutamat de sodiu, inozinat disodic, guanilat disodic), corector de aciditate (acetați de sodiu), antioxidant (extract bogat în tocoferol).',
      nutrition: [
        { name: 'Valoarea energetică', value: '2217 kJ/532 kcal' },
        { name: 'Grăsimi', value: '33 g' },
        { name: '– din care аcizi grași saturați', value: '2,5 g' },
        { name: 'Glucide', value: '51 g' },
        { name: '– din care zaharuri', value: '3,5 g' },
        { name: 'Fibre', value: '4,2 g' },
        { name: 'Proteine', value: '5,6 g' },
        { name: 'Sare', value: '1,3 g' }
      ],
      storage: 'a se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Cașcaval"': {
      ingredients: 'cartofi (62 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (33 %), zer dulce praf (din lapte), sare alimentară, dextroză, brânză sub formă de pudră, aromă (conţine produse lactate), extract de drojdie, colorant (extract de ardei roșu), antioxidant (extract bogat în tocoferol).',
      nutrition: [
        { name: 'Valoarea energetică', value: '2204 kJ/529 kcal' },
        { name: 'Grăsimi', value: '33 g' },
        { name: '– din care аcizi grași saturați', value: '2,6 g' },
        { name: 'Glucide', value: '50 g' },
        { name: '– din care zaharuri', value: '1,8 g' },
        { name: 'Fibre', value: '4,3 g' },
        { name: 'Proteine', value: '5,8 g' },
        { name: 'Sare', value: '1,3 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Chilli & Lime"': {
      ingredients: 'cartofi (63 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (31 %), zahăr, sare alimentară, praf de ceapă, praf de ardei roșu, praf de ardei chili (0,2 %), praf de usturoi, chimion măcinat, praf de tomate, piper negru, praf din suc de lămâie verde (0,01 %), aromă, antioxidant (extract bogat în tocoferol). Poate conţine urme de lapte. Fără gluten.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2167 kJ/520 kcal' },
        { name: 'Grăsimi', value: '31 g' },
        { name: '– din care аcizi grași saturați', value: '2,3 g' },
        { name: 'Glucide', value: '52 g' },
        { name: '– din care zaharuri', value: '2,2 g' },
        { name: 'Fibre', value: '4,7 g' },
        { name: 'Proteine', value: '5,8 g' },
        { name: 'Sare', value: '0,93 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Costițe"': {
      ingredients: 'cartofi (63 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (31 %), zahăr, sare alimentară, praf de ceapă, fructoză, praf de tomate, praf de bacon, praf de ardei roșu, praf de usturoi, aromă, aromă de fum, extract de drojdie, antioxidant (extract bogat în tocoferol). Poate conţine urme de lapte.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2166 kJ/519 kcal' },
        { name: 'Grăsimi', value: '31 g' },
        { name: '– din care аcizi grași saturați', value: '2,3 g' },
        { name: 'Glucide', value: '52 g' },
        { name: '– din care zaharuri', value: '2,5 g' },
        { name: 'Fibre', value: '4,5 g' },
        { name: 'Proteine', value: '5,8 g' },
        { name: 'Sare', value: '1,1 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Sare"': {
      ingredients: 'cartofi (66 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (32 %), sare alimentară (1,2 %), antioxidant (extract bogat în tocoferol). Poate conține urme de lapte.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2222 kJ/533 kcal' },
        { name: 'Grăsimi', value: '33 g' },
        { name: '– din care аcizi grași saturați', value: '2,5 g' },
        { name: 'Glucide', value: '51 g' },
        { name: '– din care zaharuri', value: '<0,5 g' },
        { name: 'Fibre', value: '4,6 g' },
        { name: 'Proteine', value: '5,7 g' },
        { name: 'Sare', value: '1,2 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Smântână și Ceapă"': {
      ingredients: 'cartofi (61 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (32 %), sare alimentară, zahăr, zer dulce praf (din lapte), praf de ceapă, dextroză, smântână praf (0,15 %), pătrunjel, praf de usturoi, aromă (conţine produse lactate), extract de drojdie, potențiatori de aromă (monoglutamat de sodiu, inozinat disodic, guanilat disodic), antioxidant (extract bogat în tocoferol).',
      nutrition: [
        { name: 'Valoarea energetică', value: '2205 kJ/529 kcal' },
        { name: 'Grăsimi', value: '33 g' },
        { name: '– din care аcizi grași saturați', value: '2,6 g' },
        { name: 'Glucide', value: '50 g' },
        { name: '– din care zaharuri', value: '2,4 g' },
        { name: 'Fibre', value: '4,4 g' },
        { name: 'Proteine', value: '5,8 g' },
        { name: 'Sare', value: '1,7 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Bacon"': {
      ingredients: 'cartofi (61 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (32 %), sare alimentară, praf de ardei roșu, praf de ceapă, zahăr, praf de bacon, praf de ardei chilli, aromă, aromă de fum, drojdie, extract de drojdie, potențiator de aromă (monoglutamat de sodiu), colorant (extract de ardei roșu), antioxidant (extract bogat în tocoferol). Poate conţine urme de lapte.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2205 kJ/529 kcal' },
        { name: 'Grăsimi', value: '33 g' },
        { name: '– din care аcizi grași saturați', value: '2,4 g' },
        { name: 'Glucide', value: '50 g' },
        { name: '– din care zaharuri', value: '<0,5 g' },
        { name: 'Fibre', value: '4,2 g' },
        { name: 'Proteine', value: '5,9 g' },
        { name: 'Sare', value: '1,9 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Legume la Grătar"': {
      ingredients: 'cartofi (63 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (31 %), zahăr, sare alimentară, praf de ceapă, praf de usturoi, praf de coriandru, praf din semințe de chimen, praf de ghimbir, cardamom, praf de curcumă, maltodextrină (din porumb), praf de fenicul, aromă, extract de drojdie, antioxidant (extract bogat în tocoferol). Poate conţine urme de lapte.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2149 kJ/515 kcal' },
        { name: 'Grăsimi', value: '31 g' },
        { name: '– din care аcizi grași saturați', value: '2,3 g' },
        { name: 'Glucide', value: '51 g' },
        { name: '– din care zaharuri', value: '1,7 g' },
        { name: 'Fibre', value: '4,7 g' },
        { name: 'Proteine', value: '5,7 g' },
        { name: 'Sare', value: '1,6 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Chipsuri „Tomate și ardei iute"': {
    ingredients: 'cartofi (62 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (32 %), zahăr, sare alimentară, praf de tomate, praf de ardei roșu, praf de ceapă, praf de usturoi, aromă, extract de drojdie, antioxidant (extract bogat în tocoferol). Poate conţine urme de lapte.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2180 kJ/523 kcal' },
        { name: 'Grăsimi', value: '32 g' },
        { name: '– din care аcizi grași saturați', value: '2,4 g' },
        { name: 'Glucide', value: '51 g' },
        { name: '– din care zaharuri', value: '2,1 g' },
        { name: 'Fibre', value: '4,5 g' },
        { name: 'Proteine', value: '5,8 g' },
        { name: 'Sare', value: '1,4 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Sticks „Bacon"': {
      ingredients: 'cartofi (65 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (28 %), sare alimentară, zahăr, praf de ardei roșu, praf de ceapă, praf de bacon (0,2 %), ardei roșu afumat măcinat, praf de ardei chili, aromă, antioxidant (extract bogat în tocoferol). PRODUSUL POATE CONȚINE URME DE LAPTE.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2126 kJ/509 kcal' },
        { name: 'Grăsimi', value: '29 g' },
        { name: '– din care аcizi grași saturați', value: '2,2 g' },
        { name: 'Glucide', value: '54 g' },
        { name: '– din care zaharuri', value: '3,0 g' },
        { name: 'Fibre', value: '4,6 g' },
        { name: 'Proteine', value: '5,8 g' },
        { name: 'Sare', value: '1,8 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Sticks „Cașcaval"': {
      ingredients: 'cartofi (65 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (28 %), sare alimentară, zahăr, praf de cașcaval (1,5 %), praf de ceapă, aromă, antioxidant (extract bogat în tocoferol). PRODUSUL POATE CONȚINE URME DE LAPTE.',
      nutrition: [
        { name: 'Valoarea energetică', value: '2126 kJ/509 kcal' },
        { name: 'Grăsimi', value: '29 g' },
        { name: '– din care аcizi grași saturați', value: '2,2 g' },
        { name: 'Glucide', value: '54 g' },
        { name: '– din care zaharuri', value: '3,0 g' },
        { name: 'Fibre', value: '4,6 g' },
        { name: 'Proteine', value: '5,8 g' },
        { name: 'Sare', value: '1,8 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    },
    'Sticks „Smântână & verdeață"': {
      ingredients: 'cartofi (65 %), uleiuri vegetale (ulei de floarea-soarelui și ulei de rapiță în proporții variate) (29 %), sare alimentară, zer dulce praf (din lapte), zahăr, dextroză, praf de ceapă (0,6%), lapte praf degresat (0,1%), smântână praf (0,1%), pătrunjel (0,1%), aromă (conține produse lactate), extract de drojdie, antioxidant (extract bogat în tocoferol).',
      nutrition: [
        { name: 'Valoarea energetică', value: '2148 kJ/515 kcal' },
        { name: 'Grăsimi', value: '30 g' },
        { name: '– din care аcizi grași saturați', value: '2,4 g' },
        { name: 'Glucide', value: '53 g' },
        { name: '– din care zaharuri', value: '2,3 g' },
        { name: 'Fibre', value: '4,6 g' },
        { name: 'Proteine', value: '5,9 g' },
        { name: 'Sare', value: '1,7 g' }
      ],
      storage: 'A se păstra în loc uscat și răcoros, ferit de razele soarelui.',
      origin: 'Produs în Polonia.'
    }
  };

  // const handleAddToCart = (chip) => {
  //   addToCart(chip);
  //   setMiniCartOpen(true);
  // };

  const handleOrderNow = (chip) => {
    // Проверяем, если это чипсы с беконом (100г), переходим на специальную ссылку
    if (chip.name === 'Chipsuri „Bacon"' && chip.weight === 100) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-bacon/', '_blank');
    }
    // Проверяем, если это чипсы с беконом (150г), переходим на специальную ссылку
    // else if (chip.name === 'Chipsuri cu Bacon' && chip.weight === 150) {
    //   window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-bacon/', '_blank');
    // }
    // Проверяем, если это чипсы с овощами на гриле (100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Legume la Grătar"' && chip.weight === 100) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-legume/', '_blank');
    }
    // Проверяем, если это чипсы с сыром (60г или 100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Cașcaval"' && (chip.weight === 60 || chip.weight === 100)) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-cascaval/', '_blank');
    }
    // Проверяем, если это чипсы с чили (60г или 100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Chilli & Lime"' && (chip.weight === 60 || chip.weight === 100)) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-chilli-lime/', '_blank');
    }
    // Проверяем, если это чипсы с крабом (150г), переходим на специальную ссылку
    // else if (chip.name === 'Chipsuri cu Crab' && chip.weight === 150) {
    //   window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-crab/', '_blank');
    // }
    // Проверяем, если это чипсы с ребрышками (150г), переходим на специальную ссылку
    // else if (chip.name === 'Chipsuri cu Costiță' && chip.weight === 150) {
    //   window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-costite/', '_blank');
    // }
    // Проверяем, если это чипсы с пиццей (150г), временно нет ссылки
    // else if (chip.name === 'Chipsuri cu Pizza' && chip.weight === 150) {
    //   alert('Ссылка для Pizza 150g временно недоступна');
    // }
    // Проверяем, если это чипсы с косточками (60г или 100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Costițe"' && (chip.weight === 60 || chip.weight === 100)) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-costite/', '_blank');
    }
    // Проверяем, если это чипсы с крабом (60г или 100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Crab"' && (chip.weight === 60 || chip.weight === 100)) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-crab/', '_blank');
    }
    // Проверяем, если это чипсы со сметаной и луком (60г или 100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Smântână și Ceapă"' && (chip.weight === 60 || chip.weight === 100)) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-smantana/', '_blank');
    }
    // Проверяем, если это чипсы с солью (60г или 100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Sare"' && (chip.weight === 60 || chip.weight === 100)) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-sare/', '_blank');
    }
    // Проверяем, если это чипсы с помидорами (100г), переходим на специальную ссылку
    else if (chip.name === 'Chipsuri „Tomate și ardei iute"' && chip.weight === 100) {
      window.open('https://banzairomania.ro/produs/chipsuri-leodor-cu-gust-de-tomate-si-ardei-iute/', '_blank');
    }
    // Проверяем, если это стики с беконом (70г), переходим на специальную ссылку
    else if (chip.name === 'Sticks „Bacon"' && chip.weight === 70) {
      window.open('https://banzairomania.ro/produs/sticks-leodor-cu-gust-de-bacon/', '_blank');
    }
    // Проверяем, если это стики с сыром (70г), переходим на специальную ссылку
    else if (chip.name === 'Sticks „Cașcaval"' && chip.weight === 70) {
      window.open('https://banzairomania.ro/produs/sticks-leodor-potato/', '_blank');
    }
    // Проверяем, если это Sticks „Smântână & verdeață" (70г), переходим на специальную ссылку
    else if (chip.name === 'Sticks „Smântână & verdeață"' && chip.weight === 70) {
      window.open('https://banzairomania.ro/produs/sticks-leodor-smantana-cu-verdeata/', '_blank');
    } else {
      alert(`Comandă plasată pentru: ${chip.name} ${chip.weight}g - ${chip.price.toFixed(2)} LEI`);
    }
  };

  const handleChipsFilter = (category) => {
    setFilter(category);
    setChipsDropdownOpen(false);
  };

  const handleSticksFilter = (category) => {
    setFilter(category);
    setSticksDropdownOpen(false);
  };

  const handleSortChange = (sortValue) => {
    setSort(sortValue);
    setSortDropdownOpen(false);
  };

  const getSortLabel = (sortValue) => {
    switch(sortValue) {
      case 'price-asc': return 'Preț Crescător';
      case 'price-desc': return 'Preț Descrescător';
      default: return 'Sortare';
    }
  };

  const handleImageClick = (chip) => {
    if (chipsInfo[chip.name]) {
      setSelectedChip(chip);
    }
  };

  const closeModal = () => {
    setSelectedChip(null);
  };

  const isChipsActive = filter === '100g' || filter === '60g';
  const isSticksActive = filter === '70g';

  // Закрытие выпадающих меню при клике вне их области
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chipsDropdownOpen && !event.target.closest('.chips-dropdown-container')) {
        setChipsDropdownOpen(false);
      }
      if (sticksDropdownOpen && !event.target.closest('.sticks-dropdown-container')) {
        setSticksDropdownOpen(false);
      }
      if (sortDropdownOpen && !event.target.closest('.sort-dropdown-container')) {
        setSortDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [chipsDropdownOpen, sticksDropdownOpen, sortDropdownOpen]);

  // Закрытие модального окна при нажатии Escape
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape' && selectedChip) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [selectedChip]);

  return (
    <ShopPage>
      <Header backgroundYellow={true} />
      <Container>
        {/* <Title>Catalogul Nostru</Title> */}{/*  This line is removed */}
        <Filters>
          <FilterButtonsContainer>
            <FilterButton active={filter === 'all'} onClick={() => setFilter('all')}>Toate</FilterButton>
            
            <ChipsDropdownContainer className="chips-dropdown-container">
              <ChipsButton 
                active={isChipsActive} 
                isOpen={chipsDropdownOpen}
                onClick={() => setChipsDropdownOpen(!chipsDropdownOpen)}
              >
                Chips
              </ChipsButton>
              <ChipsDropdown isOpen={chipsDropdownOpen}>
                <ChipsDropdownItem 
                  active={filter === '60g'} 
                  onClick={() => handleChipsFilter('60g')}
                >
                  60g
                </ChipsDropdownItem>
                <ChipsDropdownItem 
                  active={filter === '100g'} 
                  onClick={() => handleChipsFilter('100g')}
                >
                  100g
                </ChipsDropdownItem>
                {/* <ChipsDropdownItem 
                  active={filter === '150g'} 
                  onClick={() => handleChipsFilter('150g')}
                >
                  150g
                </ChipsDropdownItem> */}
              </ChipsDropdown>
            </ChipsDropdownContainer>

            <SticksDropdownContainer className="sticks-dropdown-container">
              <SticksButton 
                active={isSticksActive} 
                isOpen={sticksDropdownOpen}
                onClick={() => setSticksDropdownOpen(!sticksDropdownOpen)}
              >
                Sticks
              </SticksButton>
              <SticksDropdown isOpen={sticksDropdownOpen}>
                <SticksDropdownItem 
                  active={filter === '70g'} 
                  onClick={() => handleSticksFilter('70g')}
                >
                  70g
                </SticksDropdownItem>
              </SticksDropdown>
            </SticksDropdownContainer>
          </FilterButtonsContainer>

          <SortDropdownContainer className="sort-dropdown-container">
            <SortButton 
              open={sortDropdownOpen}
              onClick={() => setSortDropdownOpen(!sortDropdownOpen)}
            >
              {getSortLabel(sort)}
            </SortButton>
            <SortDropdown open={sortDropdownOpen}>
              <SortDropdownItem 
                active={sort === 'price-asc'} 
                onClick={() => handleSortChange('price-asc')}
              >
                Preț Crescător
              </SortDropdownItem>
              <SortDropdownItem 
                active={sort === 'price-desc'} 
                onClick={() => handleSortChange('price-desc')}
              >
                Preț Descrescător
              </SortDropdownItem>
            </SortDropdown>
          </SortDropdownContainer>
        </Filters>
        <ProductGrid>
          {filteredAndSortedChips.map(chip => {
            // const inCart = cart.find(item => item.name === chip.name && item.weight === chip.weight);
            const isChili = chip.name === 'Chipsuri „Chilli & Lime"';
            const isSare = chip.name === 'Chipsuri „Sare"';
            return (
              <ProductCard key={`${chip.name}-${chip.weight}`}>
                {isChili ? (
                  <ChiliProductImage 
                    src={chip.image} 
                    alt={chip.name} 
                    onClick={() => handleImageClick(chip)}
                    style={{ cursor: chipsInfo[chip.name] ? 'pointer' : 'default' }}
                  />
                ) : isSare ? (
                  <LargerProductImage 
                    src={chip.image} 
                    alt={chip.name} 
                    onClick={() => handleImageClick(chip)}
                    style={{ cursor: chipsInfo[chip.name] ? 'pointer' : 'default' }}
                  />
                ) : (
                  <ProductImage 
                    src={chip.image} 
                    alt={chip.name} 
                    onClick={() => handleImageClick(chip)}
                    style={{ cursor: chipsInfo[chip.name] ? 'pointer' : 'default' }}
                  />
                )}
                {isChili ? (
                  <ChiliProductInfo>
                    <div>
                      <ChiliProductName 
                        onClick={() => handleImageClick(chip)}
                        style={{ cursor: chipsInfo[chip.name] ? 'pointer' : 'default' }}
                      >
                        {chip.name}
                      </ChiliProductName>
                      <ChiliProductPrice>{chip.price.toFixed(2)} LEI</ChiliProductPrice>
                    </div>
                    <AddToCartButton onClick={() => handleOrderNow(chip)}>
                      Comandă acum
                    </AddToCartButton>
                  </ChiliProductInfo>
                ) : isSare ? (
                  <SareProductInfo>
                    <div>
                      <SareProductName 
                        onClick={() => handleImageClick(chip)}
                        style={{ cursor: chipsInfo[chip.name] ? 'pointer' : 'default' }}
                      >
                        {chip.name}
                      </SareProductName>
                      <SareProductPrice>{chip.price.toFixed(2)} LEI</SareProductPrice>
                    </div>
                    <AddToCartButton onClick={() => handleOrderNow(chip)}>
                      Comandă acum
                    </AddToCartButton>
                  </SareProductInfo>
                ) : (
                  <ProductInfo>
                    <div>
                      <ProductName 
                        onClick={() => handleImageClick(chip)}
                        style={{ cursor: chipsInfo[chip.name] ? 'pointer' : 'default' }}
                      >
                        {chip.name}
                      </ProductName>
                      <ProductPrice>{chip.price.toFixed(2)} LEI</ProductPrice>
                    </div>
                    <AddToCartButton onClick={() => handleOrderNow(chip)}>
                      Comandă acum
                    </AddToCartButton>
                  </ProductInfo>
                )}
              </ProductCard>
            );
          })}
        </ProductGrid>
      </Container>
      <MiniCart open={miniCartOpen} onClose={() => setMiniCartOpen(false)} />
      
      {selectedChip && chipsInfo[selectedChip.name] && (
        <ModalOverlay onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>{selectedChip.name}</ModalTitle>
              <CloseButton onClick={closeModal}>×</CloseButton>
            </ModalHeader>
            <ModalText>
              <h3>Ingrediente:</h3>
              {chipsInfo[selectedChip.name].ingredients}
              
              <h3>Declarație nutrițională (per 100g):</h3>
              <table>
                <tbody>
                  {chipsInfo[selectedChip.name].nutrition.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
              <h3>Condiții de păstrare:</h3>
              {chipsInfo[selectedChip.name].storage}
              
              <h3>Origine:</h3>
              {chipsInfo[selectedChip.name].origin}
            </ModalText>
          </ModalContent>
        </ModalOverlay>
      )}
    </ShopPage>
  );
};

export default Shop;